import { twClassMerge } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { OutlinedLockIcon } from '@shared/assets-icon';
import { MESSAGE_ACTIONS_KEYS } from '@shared/utils/bridge';

const { Title } = Typography;

export interface AccessNotGrantedProps {
  className?: string;
  faqDesc?: string;
  faqURL: string;
  hideIcon?: boolean;
  pageName: string;
  title?: string;
}

const AccessNotGranted = ({ className, faqDesc, faqURL, hideIcon, pageName, title }: AccessNotGrantedProps) => {
  const { t } = useTranslation();

  return (
    <div className={twClassMerge('flex flex-col gap-4 rounded-2xl bg-white px-4 pb-6 pt-4 text-sm', className)}>
      {!!title && (
        <div className="flex gap-2.5">
          {!hideIcon && (
            <OutlinedLockIcon className="size-6 [&_path]:stroke-black [&_path]:fill-black [&_circle]:fill-black" />
          )}
          {!!title && <Title className="mb-0 text-base font-bold">{title}</Title>}
        </div>
      )}
      <span>{t('noAccessGranted.title')}</span>
      <ul className="mb-0 list-inside list-disc">
        <li className="font-bold">{pageName}</li>
      </ul>
      <span className="[&_a]:font-semibold [&_a]:text-theme-600">
        <Trans
          components={{
            1: (
              <a
                className="text-theme-600"
                data-navigation={MESSAGE_ACTIONS_KEYS.externalLink}
                href={faqURL}
                rel="noopener noreferrer"
                target="_blank"
                title="FAQ"
              >
                FAQ
              </a>
            ),
          }}
          i18nKey={faqDesc ?? t('noAccessGranted.howToAccess')}
        />
      </span>
    </div>
  );
};

export default AccessNotGranted;
